/**
 * Created by Administrador on 11/14/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('ruleService', ruleService);

    ruleService.$inject = ['$http', 'CONFIG', 'messageService'];

    function ruleService($http, CONFIG, messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FARE_CONTROL + '/' + CONFIG.API + '/rules';
        var service = {
            getRules: getRules,
            getRule: getRule,
            saveRule: saveRule,
            updateRule: updateRule,
            deleteRule: deleteRule
        }

        return service;

        function getRules(page, size){
            return $http.get(urlBase + '?page=' + page + '&size=' + size)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function getRule(ruleId){
            return $http.get(urlBase + "/" + ruleId)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAError('');
                });
        }

        function saveRule(rule){
            return $http.post(urlBase, rule)
                .then(function(response){
                    messageService.register('rules');
                    return response;
                })
                .catch(function(){
                    messageService.registerError('rules');
                });
        }

        function updateRule(ruleId, rule){
            return $http.put(urlBase + "/" + ruleId, rule)
                .then(function(response){
                    messageService.registerUpdate('rules');
                    return response;
                })
                .catch(function(){
                    messageService.registerUpdate('rules');
                });
        }

        function deleteRule(ruleId){
            return $http.delete(urlBase + "/" + ruleId)
                .then(function(response){
                    messageService.registerDelete('rules');
                    return response;
                })
                .catch(function(){
                    messageService.registerDeleteError('rules');
                });
        }
    };

})();
